import React from 'react';
import { getLocalStorageItem } from '../../utils/cookieAndLocalStorageUtils';
import { redirectToLucLogin } from '../../utils/lucLogin';

class Login extends React.Component {
  componentDidMount() {
    if (getLocalStorageItem('access_token')) {
      this.props.history.push('/dashboard/units');
      return;
    }

    redirectToLucLogin();
  }

  render() {
    return null;
  }
}

export { Login };
